import { render, staticRenderFns } from "./ApEventProduct.vue?vue&type=template&id=89cb1e18&scoped=true&"
import script from "./ApEventProduct.vue?vue&type=script&lang=js&"
export * from "./ApEventProduct.vue?vue&type=script&lang=js&"
import style0 from "./ApEventProduct.vue?vue&type=style&index=0&id=89cb1e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89cb1e18",
  null
  
)

export default component.exports